export async function autoJoinHunt({ token, userId, email, fullName, employeeId, reportid, user_type }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/autoJoinHunt`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, email, fullName, employeeId, reportid, user_type }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || "Failed to join hunt");
  return data;
}
